import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  FormControl,
  TextField,
  InputAdornment,
  Button,
  IconButton,
  Icon,
  Checkbox,
  FormControlLabel,
  Typography,
  Link,
  CircularProgress,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import Logo from '../../../components/Logo';
import useStyles from './styles';
import Actions from '../../../store/ducks/auth';

const SignIn = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { auth, product } = useSelector(state => state);
  const { error, loading } = auth;

  const [values, setValues] = useState({
    credentials: {
      email: '',
      password: '',
      keepConnected: false,
    },
    showPassword: false,
  });

  useEffect(() => {
    if (error?.status && error?.msg) {
      enqueueSnackbar(error.msg, {
        variant: 'error',
      });
    }
  }, [error, enqueueSnackbar]);

  const handleLogin = event => {
    event.preventDefault();
    dispatch(Actions.requestLogin(values.credentials));
  };

  const handleChange = prop => event =>
    setValues({
      ...values,
      credentials: {
        ...values.credentials,
        [prop]: event.target.value,
      },
    });

  const handleClickShowPassword = () =>
    setValues({ ...values, showPassword: !values.showPassword });

  const handleMouseDownPassword = event => event.preventDefault();

  const handleError = type => {
    if (error) {
      return error.type === type;
    }
    return false;
  };

  return (
    <Box className={classes.container}>
      <Box className="logo-container">
        <Logo className="logo-img" />
      </Box>
      <FormControl component="form" onSubmit={handleLogin}>
        <Box className="input-container email">
          <TextField
            className="input"
            id="login-email"
            variant="outlined"
            type="email"
            label="Email"
            name="email"
            value={values.credentials.email}
            error={handleError('LOGIN_AUTH_INCORRECT')}
            onChange={handleChange('email')}
          />
        </Box>
        <Box className="input-container password">
          <TextField
            className="input"
            id="login-password"
            variant="outlined"
            type={values.showPassword ? 'text' : 'password'}
            label="Senha"
            name="password"
            value={values.credentials.password}
            error={handleError('LOGIN_AUTH_INCORRECT')}
            onChange={handleChange('password')}
            autoComplete="on"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    <Icon>
                      {values.showPassword ? 'visibility_off' : 'visibility'}
                    </Icon>
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Link
          className="forgot-password"
          variant="caption"
          to="/forgot-password"
          component={RouterLink}
          type="button"
        >
          Esqueci minha senha
        </Link>
        <Box className="btn-login-container">
          <Button
            className="btn-login"
            variant="contained"
            color="primary"
            size="large"
            type="submit"
          >
            {loading.requestingLogin ? (
              <CircularProgress
                className="btn-login-loading"
                color="inherit"
                size={24}
              />
            ) : (
              'Entrar'
            )}
          </Button>
        </Box>
        <FormControlLabel
          value="keep-connected"
          control={
            <Checkbox
              icon={<Icon>check_box_outline_blank</Icon>}
              checkedIcon={<Icon>check_box</Icon>}
              value="true"
              onChange={handleChange('keepConnected')}
            />
          }
          labelPlacement="end"
          label={
            <Typography className="keep-connected" variant="caption">
              {' '}
              Mantenha-me conectado
            </Typography>
          }
        />
      </FormControl>
      {product.loginRegisterLink && (
        <Box className="sign-up-container">
          <Button
            href={product.loginRegisterLink}
            target="_blank"
            variant="text"
            color="secondary"
            component="a"
            size="large"
          >
            <Typography className="sign-up" variant="body2">
              {product.loginRegisterText || 'Ainda não sou cadastrado'}
            </Typography>
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default SignIn;
